import { Component, OnInit, ViewChild } from '@angular/core';
import { MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { DatePipe } from '@angular/common';
import {ToastrService} from 'ngx-toastr'
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatSelectChange, MatTableDataSource } from '@angular/material';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { DashboarduiService } from '../Shared/Service/dashboardui.service';

export const MY_FORMATS = {
  parse: {
    dateInput: 'LL',
  },
  display: {
    dateInput: 'LL',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

export class idsProductList {
    id: number;
    status: String;
    hotelName: String;
    accountingDate: any;
    pusheddate: any;
    type:any
}
@Component({
  selector: 'app-redalert-audit',
  templateUrl: './redalert-audit.component.html',
  styleUrls: ['./redalert-audit.component.css','../commonStyle.css'],
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ]
})
export class RedalertAuditComponent implements OnInit {
  searchText:any;
  typ:any;
  public PGF: any = "0";
  public PGT: any = "50";
  pageSize = 50;
  pageSizeOptions: number[] = [5, 10, 250, 500];
  isIDSUser: any;
  apiresult: any;
  hotellistChannel: any[];
  hotellistproperty: any;
  ColumnHeader: boolean;
  url: string;
  maxDate: Date;
  errorMsgSubscription: boolean;
  errorMessage: string;
  displayContent: boolean;
  filterProperty: any;
  constructor(private apiCallIdsService: DashboarduiService,private toastr: ToastrService, private datePipe: DatePipe) {
    
  }
  today = new Date();
  today1:any= new Date();
  CurrentDate = new Date();
  selectedDate: any= new Date(this.today.setDate(this.today.getDate() - 1));
  selectedTOODate: any= new Date(this.today1.setDate(this.today1.getDate() - 1));
  display: Boolean = false;
  totalcount: any = 0;
  hotellistCopy: any = [];
  public idsProductList: idsProductList[];
  dataSource: MatTableDataSource<idsProductList>
  StorelstRestr: any;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  Val: string;
  selectedProperty: string;
  UID:any;
  selectedChannel: any;
  isProgressing: Boolean = false;
  public Pmscodevalue: any;
  lstgetcmlist:any[];
  hotellist: any = [];
  allproperty: any[];
  selected: string;
  Userid: any = [];
  displayedColumns: string[] = ['flowType','status', 'createdatetime'];
  selectedDeptItems:any;
  checkTodayDate:any
  currentDateStore: any;
  storeHeartBeatValue: any;
  blinkOfflineHotel: boolean = false;
  ngOnInit() {
     this.checkTodayDate = this.CurrentDate.getDate()
    console.log('check Today =', this.checkTodayDate)
    this.isProgressing = true;
      this.loadMethod();
  }

  loadMethod(){
        this.apiCallIdsService.getAlertPopupDataList()
        .subscribe(
          data => {
            console.log('readBWCRMReadAPIData Data =', data)
            if(data.length >0){
              this.errorMsgSubscription = false
              this.displayContent = true
            this.idsProductList=data;
            this.filterProperty = this.idsProductList
          this.dataSource = new MatTableDataSource(this.idsProductList);
          console.log('this.dataSource =', this.dataSource)
          this.dataSource.paginator = this.paginator;
          this.toastr.success('Data Loaded Successfully');
          this.isProgressing = false;
          }else{
            this.displayContent = false
            this.errorMsgSubscription = true
            this.errorMessage = "No Data Found"
            this.toastr.error('No Data Found');
            this.isProgressing = false;
          }
          },
          );
  }


  Search(event:any) {
    console.log('event= ', event)
    this.dataSource = this.filterProperty.filter((res: { flowType: { toString: () => string; }}) => {
      return res.flowType.toString().toLocaleLowerCase().match(this.Val.toLocaleLowerCase())
    });
    if(event == ''){
      this.Val = '';
    }
  }

  pageEvent(e) {
    console.log(e)
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  } 

}
